<mat-card class="logon_card">
  <mat-card-content>
    <form #PasswordResetEmailForm="ngForm" (ngSubmit)="onSubmit()">
      <h2>Password Vergessen</h2>
      <div>
        <p>Bitte E-Mail-Adresse eingeben,<br />um das Passwort darüber zurückzusetzen.</p>
      </div>
      <br />
      @if (!loginValid) {
        <mat-error>
          The mail is not recognized
        </mat-error>
      }
      <mat-form-field class="fill_width">
        <mat-label>Email</mat-label>
        <input matInput [(ngModel)]="email" name="email" required>
        <mat-error>
          Bitte Email-Adresse eingeben, danke.
        </mat-error>
      </mat-form-field>
      <br />
      <table>
        <tr>
          <td style="width: 80%;">
            <a routerLink="/login"> zurück</a>
          </td>
          <td style="text-align: right; width: 20%;">
            <button mat-raised-button color="primary" [disabled]="!PasswordResetEmailForm.form.valid" style="text-align: right">Senden</button>
          </td>
        </tr>
      </table>
    </form>
  </mat-card-content>
</mat-card>